import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData,
  type UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError,
  type UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse,
  updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch,
} from '../../generated';

export type UpdatePdpTitleBrandMutationVariables =
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData['path'] &
    UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData['body'];

export type UpdatePdpTitleBrandMutation = UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse;

export const useUpdatePdpTitleBrandMutation = <
  TError = UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UpdatePdpTitleBrandMutation, TError, UpdatePdpTitleBrandMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UpdatePdpTitleBrandMutation, TError, UpdatePdpTitleBrandMutationVariables, TContext>({
    mutationKey: ['UpdatePdpTitleBrand'],
    mutationFn: async ({ portfolio_id, pdp_id, ...body }: UpdatePdpTitleBrandMutationVariables) => {
      const { data } = await updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch({
        path: { portfolio_id, pdp_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUpdatePdpTitleBrandMutation.fetcher = (
  { portfolio_id, pdp_id, ...body }: UpdatePdpTitleBrandMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch({
      path: { portfolio_id, pdp_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
